<template>
	<div>
		<slot name="header" />
		<div
			v-for="item in items"
			:key="`tag-${item.mainTag.id}`"
		>
			<TagRow
				:entry="item.mainTag"
				:columns="columns"
				:can-select="canSelect"
				:checked="isSelected(item.mainTag)"
				:checkbox-always-visible="checkboxAlwaysVisible"
				@row-click="handleRowClick"
				@selection-changed="handleMainTagSelectionChanged($event, item.subtags)"
			>
				<template #col-action="{ entry, col }">
					<LabelWithTooltip
						v-slot="{ label }"
						:label="transTagLabel(entry[col.key], sportName)"
					>
						<div class="tag-name">
							{{ label }}
						</div>
					</LabelWithTooltip>
				</template>
			</TagRow>
			<div class="subtags">
				<TagRow
					v-for="subtag in item.subtags"
					:key="`subtag-${subtag.id}`"
					:entry="subtag"
					:columns="columns"
					:can-select="canSelect"
					:checked="isSelected(subtag)"
					:checkbox-always-visible="checkboxAlwaysVisible"
					@row-click="handleRowClick"
					@selection-changed="handleSelectionChanged"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import TagRow from '@videotools/js/one/components/TagList/TagRow';
import { mapGetters } from 'vuex';
export default {
	name:       'AthleteTagGrid',
	components: { TagRow },
	props:      {
		items: {
			type:     Array,
			required: true,
		},
		columns: {
			type:    Array,
			default: () => [],
		},
		checkboxAlwaysVisible: {
			type:    Boolean,
			default: false,
		},
		selectionMap: {
			type:    Object,
			default: () => {},
		},
		canSelect: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		...mapGetters({
			sportName: 'event/sportName',
		}),
	},
	methods: {
		handleRowClick(row) {
			this.$emit('row-click', row);
		},
		handleSelectionChanged(option) {
			this.$emit('selection-changed', option);
		},
		handleMainTagSelectionChanged(option, subtags) {
			subtags = subtags || [];
			this.handleSelectionChanged(option);
			for (const subtag of subtags) {
				this.handleSelectionChanged({ entry: subtag, selected: option.selected });
			}
		},
		isSelected(item) {
			return !!this.selectionMap[item.id];
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.subtags {
	::v-deep {
		.tr {
			color: var(--color-grey-300);
			&:last-child {
				border-bottom: 1px solid var(--color-grey-800) !important;
			}
		}

		.tr .td:nth-child(2) {
			padding-left: 32px;
		}
	}
}

.tbody {
	::v-deep .tr:not(.thead) .td:not(.checkbox-wrapper) {
		border-bottom: 1px solid var(--color-grey-850);
	}
}
</style>
